import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {LocalStorageService} from 'ngx-webstorage';
import {NgIf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {UserSessionService} from '../../services/user-session.service';
import {IfHasAnyPermissionDirective} from '../../directives/if-has-any-permission.directive';
import {Backend, PERMISSION} from '@generated-backend-types';
import {IfHasAllPermissionsDirective} from '../../directives/if-has-all-permissions.directive';
import {IfHasAnyRoleDirective} from '../../directives/if-has-any-role.directive';
import RoleEnum = Backend.App.Enums.Auth.RoleEnum;

enum CONTENT {
  ADMINISTRATIONS,
  QUALITY_MANAGEMENT,
  TIME_TRACKING,
}

interface Item {
  collapsed: boolean
  content: CONTENT
}

@Component({
  selector: 'app-sidebar',
  imports: [
    RouterLinkActive,
    RouterLink,
    NgIf,
    TranslatePipe,
    IfHasAnyPermissionDirective,
    IfHasAllPermissionsDirective,
    IfHasAnyRoleDirective,
  ],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  public readonly content = CONTENT;

  public items = [
    {content: CONTENT.ADMINISTRATIONS, collapsed: true},
    {content: CONTENT.QUALITY_MANAGEMENT, collapsed: true},
    {content: CONTENT.TIME_TRACKING, collapsed: true},
  ];
  protected readonly PERMISSION = PERMISSION;
  protected readonly Backend = Backend;
  protected readonly RoleEnum = RoleEnum;

  public constructor(
    private userSessionService: UserSessionService,
    private readonly storageService: LocalStorageService,
  ) {}

  public logout() {
    this.userSessionService.logout().subscribe();
  }

  public ngOnInit() {
    this.updateState(this.storageService.retrieve('sidebarState'));
  }

  public collapsed(content: CONTENT): boolean {
    const index = this.items.findIndex(v => v.content === content);
    return this.items[index].collapsed ?? false;
  }

  public toggle(content: CONTENT) {
    const index = this.items.findIndex(v => v.content === content);

    if (!this.items[index]) {
      return;
    }
    this.items[index].collapsed = !this.items[index].collapsed;

    // Save collapsed state to localStorage
    this.storageService.store('sidebarState', JSON.stringify(this.items));
  }

  private updateState(collapsedState: string) {
    if (collapsedState) {
      const parsed = JSON.parse(collapsedState);
      this.items = this.items
        .map((item: Item, index) => {
          return {content: item.content, collapsed: parsed[index].collapsed ?? false}
        });
    }
  }
}
